import React from 'react'
import withWindowDimensions from 'components/common/withWindowDimensions'
import Image from 'next/image'
import Button from 'components/LSRevamp/common/Button'
import { LoginProps, withLogin } from 'components/Login/withLogin'
import { pageName } from 'utils/events-utils'
import { trackClick } from 'scripts/segment'

interface Props {
  isMobileSized?: boolean
}

const ConnectWithCounsellor: React.FC<Props & LoginProps> = ({
  isMobileSized,
  handleSpotCounsellingFlow,
}) => {
  return (
    <div className="text-white md:justify-center md:m-auto bg-[#645FA5] flex flex-col lg:flex-row  text-center  lg:text-left bg-contain bg-[url(`${process.env.CDN_URL}/assets/images/LSRevamp/background.svg`)] bg-no-repeat bg-[center_bottom_5rem] lg:bg-right xl:pr-[157px]">
      <div className="flex flex-col  xl:pl-[161px] md:px-4 lg:mr-[17px] ">
        <h2 className="lg:w-[560px] font-bold  mt-[25px] text-[24px] lg:text-[42px] px-[24px] lg:px-0 lg:mt-[120px] leading-[30.24px] md:leading-[52.92px]">
          Connect with the counsellor at every step of your application with
          ease
        </h2>
        <h3 className=" lg:w-[479px] text-[16px] lg:text-[22px] mt-[16px] lg:mt-[41px]  px-[32px] lg:px-0 leading-6 md:leading-[33px]">
          Our Counsellors are available through out chat and video call support
          at each step of your application process
        </h3>
        {!isMobileSized ? (
          <div className="mt-[19px] font-bold mb-[31px] lg:mt-[42px]">
            <Button
              text="Talk to a Counsellor"
              color="text-white"
              backgroundColor="bg-yellow-to-orange"
              handleSpotCounsellingFlow={handleSpotCounsellingFlow}
              width="w-[255px]"
              border="border-0"
              trackingEvent={() => {
                trackClick(pageName.CounsellorPage, {
                  contentName: 'Talk to a Counsellor',
                  widgetName: 'Connect With Counsellor',
                  widgetFormat: 'Banner',
                  contentFormat: 'Button',
                })
              }}
            />
          </div>
        ) : null}
      </div>

      <div className="mt-[41px]  lg:mt-[86px] lg:mb-[63px]">
        <Image
          src= {`${process.env.CDN_URL}/assets/images/LSRevamp/group-pic.png`}
          height={isMobileSized ? 290 : 555}
          width={isMobileSized ? 284 : 544}
          alt={'counsellor-photo'}
        />
      </div>
      {isMobileSized ? (
        <div className="mt-[19px] font-bold mb-[31px] ">
          <Button
            text="Talk to a Counsellor"
            color="text-white"
            backgroundColor="bg-yellow-to-orange"
            width="w-[255px]"
            handleSpotCounsellingFlow={handleSpotCounsellingFlow}
            border="border-0"
            trackingEvent={() => {
              trackClick(pageName.CounsellorPage, {
                contentName: 'Talk to a Counsellor',
                widgetName: 'Connect With Counsellor',
                widgetFormat: 'Banner',
                contentFormat: 'Button',
              })
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default withWindowDimensions(withLogin(ConnectWithCounsellor))
